import { FIELD_TYPE, FORMAT_TIME } from "types/enums";
import { DataFormField } from "types/models/input-field-type";
const { INPUT, DATE, COMBO_BOX, AUTO_COMPLETE, CURRENCY, NUMBER, DATE_PRE } =
  FIELD_TYPE;
const listMonths = [];
for (let month = 1; month <= 12; month++) {
  listMonths.push({
    value: month,
    label: `Tháng ${month}`,
  });
}

//--------------------------------------------------------
const listYears = [];
const currentYear = new Date().getFullYear();
const startYear = 2020;
const endYear = currentYear + 100;
for (let year = startYear; year <= endYear; year++) {
  listYears.push({
    value: year,
    label: year.toString(),
  });
}
const css = { xs: 24, sm: 24, md: 24, lg: 8, xl: 8 };
const dataFields: DataFormField[] = [
  {
    type: COMBO_BOX,
    label: "Số giờ/tuần",
    name: "idSoGioTrenTuan",
    disable: false,
    rules: [{ required: true, message: "Chưa nhập số giờ/tuần" },
  ],
    css: css,
    wrapperCol: { xs: 24, sm: 14, md: 16, lg: 16, xl: 16 },
    labelCol: { xs: 24, sm: 10, md: 8, lg: 8, xl: 8 },
  },
  {
    type: AUTO_COMPLETE,
    name: "thang",
    label: "Tháng",
    disable: false,

    options: listMonths,
    rules: [{ required: true, message: "Chưa nhập tháng" }],
    css: css,
    wrapperCol: { xs: 24, sm: 14, md: 16, lg: 16, xl: 16 },
    labelCol: { xs: 24, sm: 10, md: 8, lg: 8, xl: 8 },
  },
  {
    type: AUTO_COMPLETE,
    name: "nam",
    label: "Năm",
    disable: false,
    rules: [{ required: true, message: "Chưa nhập năm" }],
    options: listYears,
    css: css,
    wrapperCol: { xs: 24, sm: 14, md: 16, lg: 16, xl: 16 },
    labelCol: { xs: 24, sm: 10, md: 8, lg: 8, xl: 8 },
  },
  {
    type: INPUT,
    name: "soNgayCongChuan",
    label: "Ngày công chuẩn",
    disable: false,
    rules: [
      { required: true, message: "Chưa nhập ngày công chuẩn" },
      {
        pattern: /^\d+(\.\d+)?$/, // Quy tắc cho phép nhập số thập phân
        message: "Chỉ cho phép nhập số và số thập phân"
      }
    ],
    css: css,
    wrapperCol: { xs: 24, sm: 14, md: 16, lg: 16, xl: 16 },
    labelCol: { xs: 24, sm: 10, md: 8, lg: 8, xl: 8 },
  }
  
];
export { dataFields };
